export const L10N = {
  LABEL_WHO: { id: 'core.label.who', defaultMessage: '　　　' },
};
